import { FC, MouseEventHandler } from 'react'

import { ReactSVG } from 'react-svg'

import cn from 'classnames'

import SortIcon from './sort-icon.svg'
import styles from './styles.module.scss'

interface Props {
  className?: string
  isActive?: boolean
  onClick?: MouseEventHandler
  isSorting?: boolean
}

const FilterButton: FC<Props> = ({ className, isActive, onClick, isSorting }) => {
  return isSorting ? (
    <div onClick={onClick} className={styles.cnt}>
      <ReactSVG src={SortIcon} className={cn(styles.sortIcon, className)} />
    </div>
  ) : (
    <svg className={className} width="12" height="12" viewBox="0 0 12 12" fill="none" onClick={onClick}>
      <path d="M1 3L11 3" stroke={isActive ? '#1168F1' : '#898989'} strokeLinecap="round" />
      <path d="M3 6H9" stroke={isActive ? '#1168F1' : '#898989'} strokeLinecap="round" />
      <path d="M4 9H8" stroke={isActive ? '#1168F1' : '#898989'} strokeLinecap="round" />
    </svg>
  )
}

export default FilterButton
